
import React, { Component } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/index.css';
import RouterAgent from './RouterAgent';
import RouterPublic from './RouterPublic';
import RouterEmbedded from './RouterEmbedded';

class App extends Component {

    render() {

        let r = process.env.REACT_APP_AUDIENCE == 'agent' ? <RouterAgent /> : <RouterPublic />;

        // Also see PropertyCalculator.jsx
        if (window.location.search.includes('embed')) {
            r = <RouterEmbedded />
        }

        return (
            <React.Fragment>
                {r}
            </React.Fragment>
        );
    }
}

export default hot(module)(App);




// WEBPACK FOOTER //
// ./src/components/App/App.jsx